// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__c4-wJ","Primary":"Button_Primary__Olzvs","Secondary":"Button_Secondary__uKzRp","Outline":"Button_Outline__1PYPS","Dotted":"Button_Dotted__a9l4X"};